import { portalEnv } from './config/portalEnv';

export const Configurl = {
  DefaultOrganizationLogo: portalEnv.defaultOrganizationLogo,
  OrganizationName: portalEnv.organizationName,
  apiBaseUrl: portalEnv.apiBaseUrl,
  feedFeatureApiBaseUrl: portalEnv.feedFeatureApiBaseUrl,
};

export default Configurl;
